export class AuthModel {
  accessToken: string;
  refreshToken: string;


  setAuth(auth: any) {
    this.accessToken = auth.accessToken;
    // this.expiresIn = auth.expiresIn;
  }
}

export class Oauth  {
  siteKey: string;
  appId: string;
  appIdGoogle: string;
  authority: string;
  tenantName: string;
  redirectUri: string;
  scopes: string[];
}
export class TokenRequest{
  Token:string;
}